<template>
  <v-navigation-drawer
    v-model="showRightMenu"
    class="navigation-menu"
    width="300"
    right
    fixed
    touchless
    clipped
  >
    <v-list class="px-1 py-5 no-hover-menu-el">
      <v-list-item class="pt-1 pb-2" tag="div" @click="goHomeAndClearSearch">
        <v-list-item-content>
          <v-list-item-title style="color: white;" class="pt-2">
            <v-icon color="white" class="pr-2 mt-n2">fa-home</v-icon>
            {{ capitalize($t('go_home')) }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            fab
            x-small
            class="elevation-0 mt-1 mr-0"
            @click.stop="showRightMenu = false"
            color="white"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-row class="pt-2">
        <v-col cols="12" class="mt-2 mx-3">
          <flags className="flags-menu" />
        </v-col>
        <v-col
          cols="12"
          v-if="favorites.length > 0"
          style="line-height: 18px; color: white;"
          class="mt-n2 mb-n3 mx-3"
          @click="showFavoritesFromRightMenu()"
        >
          <i
            class="fa fa-heart"
            style="font-size: 18px; padding-right: 5px;"
          />
          {{ $t('saved_favorites') }}
        </v-col>
      </v-row>

    </v-list>

    <v-list class="pt-0" dense>
      <template
        v-for="(key, menuIndex) in Object.keys(menu)"
      >
        <div
          v-if="menu[key]['menuName_' + lang] && menu[key].showOnMobile"
          :key="menuIndex"
          @click="showPageId(menu[key])"
          class="first-level"
        >
          {{ menu[key]['menuName_' + lang] }}
        </div>

        <div
          v-for="(submenuItem, menuIndex2) in menu[key].children
            .filter(name => !!name[['menuName_' + lang]] && name.showOnMobile)"
          :key="menuIndex + '_' + menuIndex2 + '_lm'"
          @click="showPageId(submenuItem)"
          class="mobile-second-level"
        >
           - {{ submenuItem[['menuName_' + lang]] }}
        </div>
      </template>
    </v-list>
    <v-list>
      <v-row>
        <v-col cols="12" class="mt-2 mx-3 mb-3">
          <main-share color="white" />
        </v-col>
      </v-row>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
import MainShare from '../Extras/_MainShare'
import Flags from '../Header/Flags'
import sharedMethods from '../../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'MobileRightMenu',

  components: {
    Flags,
    MainShare
  },

  data () {
    return {
      showMenuId: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    menu () {
      const menu = {}
      // level 1
      this.menuResponse.forEach(item => {
        if (!item.parent) {
          menu[item._id] = item
          menu[item._id].children = []
        }
      })
      // level 2
      this.menuResponse.forEach(item => {
        if (item.parent && item.parent._id && menu[item.parent._id]) {
          menu[item.parent._id].children.push(item)
        }
      })
      return menu
    }
  },

  methods: {
    ...sharedMethods,

    showFavoritesFromRightMenu () {
      this.goToFavorites()
      this.showRightMenu = false
    },

    showMenu (id) {
      this.showMenuId = id
    },

    hideMenu () {
      this.showMenuId = null
    }
  }
}
</script>

<style lang="scss">
.navigation-menu {
  background: #219bc8 !important;
  color: white;
}
.first-level {
  cursor: pointer;
  font-weight: bold;
  color: white;
  padding: 10px 15px 2px 15px;
}
.mobile-second-level {
  cursor: pointer;
  padding: 0 10px 0 25px;
  color: white;
  height: 32px;
  line-height: 32px;
}
.mobile-second-level:hover {
  background: #ffcb01;
}
.bedroom-button {
  border-radius: 4px;
  margin: 3px 5px;
  padding: 5px;
  text-align: center;
  border: 1px solid grey;
  color: white;
  width: 30px;
  height: 30px;
  line-height: 20px;
  background: #ffcb01;
  cursor: pointer;
  float: left;
}
.no-hover-menu-el {
  .theme--light.v-list-item:hover::before {
    opacity: 0 !important;
  }
}
</style>
